<template>
  <div class="flex flex-row justify-between">
    <div class="flex h-full w-fit items-center justify-between gap-5 lg:hidden">
      <SFButton
        variant="raw"
        class="-mt-1"
        data-testid="side-navigation-button"
        :aria-label="$t('navigation.a11ly.side_navigation')"
        @click="toggleMenu"
      >
        <template #icon>
          <IconClose v-if="isSideNavigationOpen" class="size-6" />
          <IconBurger v-else class="size-6" />
        </template>
      </SFButton>

      <SFLogoLink
        data-testid="header-logo"
        class="flex h-8 w-auto max-w-[71px] items-center"
        @click="isSideNavigationOpen = false"
      />
    </div>

    <div class="-mt-1 flex items-center gap-x-6 lg:hidden">
      <SFHeaderUserIcons @click="isSideNavigationOpen = false" />
    </div>
  </div>

  <ClientOnly>
    <SFSlideInFromLeftTransition>
      <SFMobileSidebar
        v-popover="isSideNavigationOpen"
        class="fixed left-0 top-[86px] !m-0 h-[calc(100dvh-65px)] w-screen bg-white !p-0 lg:hidden"
        :class="{
          'block-scrolling': isSideNavigationOpen,
          hidden: !isSideNavigationOpen,
        }"
        :is-open="isSideNavigationOpen"
        :navigation-items="mainNavigationItems"
        @close="isSideNavigationOpen = false"
      />
    </SFSlideInFromLeftTransition>
  </ClientOnly>
</template>

<script setup lang="ts">
import type { NavigationItems } from '@scayle/storefront-nuxt'
import SFLogoLink from '../../SFLogoLink.vue'
import SFMobileSidebar from './SFMobileSidebar.vue'
import SFButton from '~/modules/ui/runtime/components/core/SFButton.vue'
import SFHeaderUserIcons from '~/components/layout/headers/SFHeaderUserIcons.vue'
import { ClientOnly } from '#components'
import SFSlideInFromLeftTransition from '~/modules/ui/runtime/components/transitions/SFSlideInFromLeftTransition.vue'
import { vPopover } from '~/modules/ui/runtime/directives/popover'

const isSideNavigationOpen = defineModel('isSideNavigationOpen', {
  type: Boolean,
})

defineProps<{
  mainNavigationItems: NavigationItems
}>()

const toggleMenu = () =>
  (isSideNavigationOpen.value = !isSideNavigationOpen.value)
</script>
